import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getApproverHideColumnsAPI = createApi("GetApproverHideColumns","GET");

const GetApproverHideColumns = createSlice({
  name: 'GetApproverHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getApproverHideColumnsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getApproverHideColumnsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getApproverHideColumnsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetApproverHideColumns.reducer;